import * as XLSX from 'xlsx';

/**
 * Build a worksheet from an array of plain objects (keys = column headers) and download as .xlsx
 * @param {string} filename - File name (should end with .xlsx)
 * @param {string} sheetName - Excel sheet name (max 31 chars)
 * @param {Array<Record<string, string|number>>} rows
 * @returns {boolean} false if there is nothing to export
 */
export function downloadXlsxFromRows(filename, sheetName, rows) {
  if (!rows || rows.length === 0) {
    return false;
  }
  const safeName = (sheetName || 'Sheet1').slice(0, 31);
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, safeName);
  const name = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  XLSX.writeFile(wb, name);
  return true;
}
